var dialog4i = function () {
	var dialog,
	      triggerElement,
	      origFocus,
	      focusOnOpen,

	// initialize, binding the open event to the clicked element
	init = function (dlg, opensDlg, focusEl) {
		dialog = dlg;
            	
            	// if openDlg is delcared, use it, otherwise origFocus can be set manually
		if (typeof opensDlg !== 'undefined' && opensDlg.length > 0) {
			triggerElement = opensDlg;
			// if multiple trigger elements
			if (opensDlg.length > 0) {			
				for (var i = 0; i < opensDlg.length; i++) {					
					triggerElement[i].addEventListener("click", clickOpen);
					origFocus = triggerElement[i];
				}
			}
			// if single element
			else {
				triggerElement.addEventListener("click", clickOpen);
				origFocus = triggerElement;
			}
		}
		else { opensDlg = null; }
            	
            	// if focusEl is declared, use it, otherwise focus on close icon
		if (typeof focusEl !== 'undefined') {
			focusOnOpen = focusEl;
		} 
		else { focusOnOpen = dialog.querySelectorAll('.close4iDialog')[0]; }
	},
	bindCloseElements = function () {
		var closeElements = dialog.querySelectorAll('.close4iDialog');
		for (var i = 0; i < closeElements.length; i++) {
			closeElements[i].addEventListener("click", clickClose);
		}
	},
	unbindCloseElements = function () {
		var closeElements = dialog.querySelectorAll('.close4iDialog');
		for (var i = 0; i < closeElements.length; i++) {
			closeElements[i].removeEventListener("click", clickClose);
		}
	},
	// prevent the screen from jumping to top on close/open in init
	clickOpen = function (e) {
		e.preventDefault();
		open();
	},
	clickClose = function (e) {
		e.preventDefault();
		close();
	},
	// open dialog
	open = function() {
		// get first and last focusable element within dialog
		var focusableEls = dialog.querySelectorAll('a, button:not([disabled]), [href], .close4iDialog, input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'),
		      firstFocusableEl = focusableEls[0],
		      lastFocusableEl = focusableEls[focusableEls.length - 1];
		
		dialog.classList.add('showDialog');
		dialog.setAttribute('aria-hidden', 'false');
		focusOnOpen.focus();
		bindCloseElements();
		
		// trapping focus
		dialog.addEventListener('keydown', function (e) {
			var tab = (e.which || e.keyCode) === 9,
			     esc = (e.which || e.keyCode) === 27;

			if (e.key === 'Tab' || tab) {
				if (e.shiftKey) /* shift + tab */ {
					if (document.activeElement === firstFocusableEl) {
						lastFocusableEl.focus();
						e.preventDefault();
					}
				} else /* tab */ {
					if (document.activeElement === lastFocusableEl) {
						firstFocusableEl.focus();
						e.preventDefault();
					}
				}
			} else if (esc) /* escape */ { close(); }
		});
	},
	// close dialog
	close = function() {	
		dialog.classList.remove('showDialog');
		dialog.removeEventListener('keydown', [0]);
		if (typeof origFocus !== 'undefined') {
			origFocus.focus(); 
		}
		dialog.setAttribute('aria-hidden', 'true');
		unbindCloseElements();
	};
	return {
		init: init, // open and close are only really exposed in case they need to be called programatically somewhere. Just calling init handles everything internally for most scenarios.
		open: open,
		close: close
	};
	/* --SML 
        * Example of usage:
        * var deleteCartItemDialog = dialog4i();
        * deleteCartItemDialog.init(document.getElementById('confirmDelete'), document.getElementsByClassName('cartDeleteBtn'), document.getElementById('btnConfirmDelete'));
        */
};